/* eslint-disable import/no-named-as-default */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable import/no-duplicates */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// @ts-ignore
import { LOGGING_OUT } from '@actions/common';
import B2ChatClient from '@client-sdk';
import {
  activateSession,
  deactivateSession,
  suspendSession,
} from '@reducers/singletonSession';
import { createAction } from '@reduxjs/toolkit';
import { loginActionCreator } from '@src/actions/loginAuthenticationAction';
import appConfig from '@src/config/appConfig';
import globalHistory from '@src/globalHistory';
import { TwoFactorAuthApi } from '@src/reducers/twoFactorAuthApi';
import { LoginSuccess } from '@src/types';
import { B2ChatAPI } from '@src/types/api';
import { call, put, takeLeading } from 'redux-saga/effects';
import isPublicRoute from '@utils/isPublicRoute';
import { LOGGED_IN_USER_RELOADED } from '../actions/loginAuthenticationAction';
import {
  createStorageChannelEvent,
  emitStorageEvent,
  StorageChannelEvent,
} from './storageChannelEvent';

const IGNORED_PATHS = ['/viewer'];
const SUSPEND_NOTIFICATION = 'notification:suspend';
const LOGGING_OUT_NOTIFICATION = 'notification:logging-out';

const ignoreCurrentPath = () => {
  const currentPath = globalHistory.location.pathname;
  return IGNORED_PATHS.some(
    path => currentPath.substring(0, path.length) === path
  );
};

function* suspendSiblingTabs() {
  if (document.visibilityState === 'visible' && !ignoreCurrentPath()) {
    yield call(emitStorageEvent, SUSPEND_NOTIFICATION);
  }
  yield call(checkSession);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function* suspendCurrentTab(_: StorageChannelEvent) {
  if (!ignoreCurrentPath()) {
    yield put(suspendSession());
    yield call(checkSession);
  }
}

function* logoutSiblingTabs() {
  yield call(emitStorageEvent, LOGGING_OUT_NOTIFICATION);
}

function* logoutCurrentTab() {
  yield call(checkSession);
}

function* deactivateCurrentTab() {
  // eslint-disable-next-line no-restricted-globals
  yield call([location, location.assign], 'https://www.b2chat.io');
}

export const checkSessionAction = createAction('CHECK_SESSION');

function* checkSession() {
  try {
    const authMethods = yield call(
      TwoFactorAuthApi.endpoints.getAuthMethods.initiate
    );

    if (authMethods.data?.email_otp_enabled) {
      const userAuthMethodEmailOtp = yield call(
        TwoFactorAuthApi.endpoints.getUserAuthMethodEmailOtp.initiate
      );

      if (userAuthMethodEmailOtp.data.enabled) {
        yield call(
          [window.history, window.history.pushState],
          null,
          '',
          '/login/2fa/otp'
        );
      } else if (
        authMethods.data.otp_mandatory &&
        ['/login', '/'].includes(window.location.pathname)
      ) {
        yield call(
          [window.history, window.history.pushState],
          null,
          '',
          '/login/2fa/setup'
        );
      }
    }

    const authorities: B2ChatAPI.Response<LoginSuccess> = yield call(
      B2ChatClient.resources.user.actions.getCurrentUser
    );

    if (authorities.data) {
      appConfig.setCurrentUser(authorities.data); //TODO managements user without storage

      yield put(loginActionCreator(authorities.data));

      // eslint-disable-next-line no-restricted-globals
      if (['/login', '/'].includes(location.pathname)) {
        if (authorities.data.admin) {
          // eslint-disable-next-line no-restricted-globals
          yield call([history, history.pushState], null, '', '/admin/audit');
        }
        if (authorities.data.agent) {
          // eslint-disable-next-line no-restricted-globals
          yield call([history, history.pushState], null, '', '/agent/chat');
        }
      }
    } else if (!isPublicRoute()) {
      // Session is invalid (expired or never existed) and the user is not on
      // a public route — redirect so they don't end up on a blank screen.
      window.location.href = '/login';
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    // If getCurrentUser throws (e.g. network error or 401), apply the same
    // redirect so the user isn't stranded on a blank screen.
    if (!isPublicRoute()) {
      window.location.href = '/login';
    }
  }
}

export default function* singletonSession() {
  yield call(checkSession);
  yield takeLeading(checkSessionAction, checkSession);

  // push an event to request suspend the rest of the tabs
  yield takeLeading(
    [activateSession, LOGGED_IN_USER_RELOADED],
    suspendSiblingTabs
  );

  // suspend the current tab
  const SuspendTabsChannelEvent =
    createStorageChannelEvent(SUSPEND_NOTIFICATION);
  // const HistoryChannelEvent = createHistoryChannelEvent();
  yield takeLeading(SuspendTabsChannelEvent, suspendCurrentTab);

  // navigate to external site
  yield takeLeading(deactivateSession, deactivateCurrentTab);

  // notify logout to sibling tabs
  yield takeLeading(LOGGING_OUT, logoutSiblingTabs);

  // redirect to login on logging out
  const LoggingOutChannelEvent = createStorageChannelEvent(LOGGING_OUT);
  yield takeLeading(LoggingOutChannelEvent, logoutCurrentTab);
}
